module.exports = __webpack_public_path__ + "static/img/2e8d3a7156acec8f03df130dfae77406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_51.jpg
// module id = zyBR
// module chunks = 1